var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPersonSearch = function SvgPersonSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "person_search_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#person_search_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 12q-1.65 0-2.825-1.175T7 8t1.175-2.825T11 4t2.825 1.175T15 8t-1.175 2.825T11 12m0-2q.825 0 1.412-.588Q13 8.826 13 8q0-.824-.588-1.412A1.93 1.93 0 0 0 11 6q-.825 0-1.412.588A1.93 1.93 0 0 0 9 8q0 .825.588 1.412Q10.175 10 11 10m10.4 12.8-2.5-2.5q-.525.3-1.125.5T16.5 21q-1.875 0-3.187-1.312Q12 18.375 12 16.5t1.313-3.187T16.5 12t3.188 1.313Q21 14.624 21 16.5q0 .675-.2 1.275t-.5 1.125l2.5 2.5a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275M16.5 19q1.05 0 1.775-.725T19 16.5t-.725-1.775T16.5 14t-1.775.725T14 16.5t.725 1.775T16.5 19M3 18v-.775q0-.85.425-1.575t1.175-1.1q1.275-.65 2.875-1.1t3.55-.45q-.3.45-.513.963a6.6 6.6 0 0 0-.337 1.062q-1.5.125-2.675.512-1.175.388-1.975.813a.9.9 0 0 0-.388.362Q5 16.95 5 17.226V18h5.175q.125.55.337 1.05t.513.95H5q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 18"
  }))));
};
export default SvgPersonSearch;